<template>
  <div class="r_h_100">
    <div class="r_h_100" v-if="!company_loaded">
      <loadingCube :loadingMessage="'COMPANY'"></loadingCube>
    </div>
    <div v-else id="company_right_info">
      <div id="ri_w_top">
        <button class="btn orcaBtn grey_bg" id="right_info_close" data-toggle="tooltip" title="Close information" @click="close_right_info">
          <i class="fas fa-times"></i> &nbsp;CLOSE
        </button>
        <div class="quick_btns">
          <router-link v-if="$store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')" :to="{name: 'a_timesheet_r2_select_period', params: {company_id: company.id}}">
            <button class="btn orcaBtn greenBtn mb-2 mr-1 ml-1">Timesheets</button>
          </router-link>
          <button @click="show_record_company" class="btn orcaBtn greenBtn mb-2 mr-1 ml-1" data-toggle="tooltip" title="View Record"><i class="fas fa-store-alt"></i></button>
          <button v-if="$store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')" @click="delete_company"
                  class="btn orcaBtn danger mb-2 mr-1 ml-1" data-toggle="tooltip" title="Delete Company"><i class="fas fa-trash-alt"></i></button>
        </div>

        <!-- Company information -->
        <hr class="mt-1 mb-2">
        <h2 class="font-weight-bold bp_color mb-0">{{ company.company_name }}</h2>
        <h5>{{ company.rel_profile.ltd_reg_number }}</h5>
        <p class="b3_color mb-0" v-if="company.primary_consultant_id !== null"><strong>Consultant:</strong> {{ company.primary_consultant.first_name }}
          {{ company.primary_consultant.surname }}</p>

        <hr class="mt-2 mb-2">
      </div>
      <div class="ri_w_after_top">
        <div class="row">
          <div class="col-xl-5 font-weight-bold">Office Number:</div>
          <div v-if="company.rel_profile.office_phone_id !== null && company.rel_profile.office_phone !== null" class="col-xl-7">{{ company.rel_profile.office_phone.phone_number }}</div>
          <div v-else class="col-xl-7"></div>
          <div class="col-xl-5 font-weight-bold">Office Email:</div>
          <div v-if="company.rel_profile.office_email_id !== null && company.rel_profile.office_email !== null" class="col-xl-7">{{ company.rel_profile.office_email.email_address }}</div>
          <div v-else class="col-xl-7"></div>
          <div class="col-12">
            <hr>
          </div>
        </div>

        <!-- Contacts -->
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="bp_color">Contacts</h5>
            </div>
          </div>
          <button @click="add_contact_modal" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="Add Contact">
            <i class="fas fa-plus"></i> &nbsp; add contact
          </button>
          <div v-if="contacts_loaded" class="row mt-1">
            <div v-if="notEmptyObject(contacts)" class="col-12" id="contacts_box">
              <div v-for="contact in contacts" class="all_contacts">
                <div class="contact_details">
                  <span class="contact_name">{{ contact.person.first_name }} {{ contact.person.surname }}</span>
                  <span v-if="contact.rel_profile.job_title_id !== null && contact.rel_profile.job_title !== null" class="contact_job_title">{{
                      contact.rel_profile.job_title.job_title }}</span>
                  <!-- Phone Numbers-->
                  <span class="contact_pm" v-if="contact.phones.personal_landline !== null"><i class="fas fa-phone-alt"></i> {{ contact.phones.personal_landline }}</span>
                  <span class="contact_pm" v-if="contact.phones.work_landline !== null"><i class="fas fa-phone-alt"></i> {{ contact.phones.work_landline }}</span>
                  <span class="contact_pm" v-if="contact.phones.personal_mobile !== null"><i class="fas fa-mobile-alt"></i> {{ contact.phones.personal_mobile }}</span>
                  <span class="contact_pm" v-if="contact.phones.work_mobile !== null"><i class="fas fa-mobile-alt"></i> {{ contact.phones.work_mobile }}</span>
                  <!-- Email -->
                  <span class="contact_e" v-if="contact.emails.personal_email !== null"><i class="fas fa-at"></i> {{ contact.emails.personal_email }}</span>
                  <span class="contact_e" v-if="contact.emails.work_email !== null"><i class="fas fa-at"></i> {{ contact.emails.work_email }}</span>
                </div>
              </div>
            </div>
            <div v-else class="col-12 ri_w_no_content">
              <p class="ri_w_label">No Contacts for Company.</p>
            </div>
          </div>
          <div v-else class="row mt-2">
            <div class="col-12">
              <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Contacts</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="bp_color">Notes</h5>
            </div>
          </div>
          <button @click="add_note_modal" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="Add note to Company/Contact">
            <i class="fas fa-plus"></i> &nbsp; add note
          </button>
          <div v-if="notes_loaded" class="row mt-1">
            <div v-if="notEmptyObject(notes)" class="col-12">
              <div v-for="note in notes" class="last_notes">

                <button v-if="note.belongs_to_type === 'App\\Models\\Companies\\Contacts\\Contact'"
                        @click="view_note_modal(note.id, 'contact', note.belongs_to.person.first_name + ' ' + note.belongs_to.person.surname)"
                        class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip" title="View Worker Note"><i class="fas fa-eye"></i></button>
                <button v-if="note.belongs_to_type === 'App\\Models\\Companies\\Company'" @click="view_note_modal(note.id, 'company', note.belongs_to.company_name)"
                        class="btn orcaBtn greenBtn sm-btn" data-toggle="tooltip" title="View Worker Note"><i class="fas fa-eye"></i></button>

                <div class="note_details">
                  <span class="note_on" v-if="note.belongs_to_type === 'App\\Models\\Companies\\Company'">{{ note.belongs_to.company_name }}</span>
                  <span class="note_on" v-if="note.belongs_to_type === 'App\\Models\\Companies\\Contacts\\Contact'">{{ note.belongs_to.person.first_name }}
                    {{ note.belongs_to.person.surname }}</span>

                  <span class="note_type">{{ note.note_type.note_type }}</span>
                  <span class="note_user_created_at">{{ note.note_log_by.first_name }} {{ note.note_log_by.surname }} - {{ note.note_logs.updated_at | formatDateTime }}</span>
                </div>
              </div>
            </div>
            <div v-else class="col-12 ri_w_no_content">
              <p class="ri_w_label">No Notes left on Company or Contacts.</p>
            </div>
          </div>
          <div v-else class="row mt-2">
            <div class="col-12">
              <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Notes</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          </div>
        </div>

        <!-- Activity -->
<!--        <div class="ri_w_section">-->
<!--          <div class="row">-->
<!--            <div class="col-12">-->
<!--              <h5 class="bp_color">Latest Activity on Record</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <button @click="view_all_company_activity" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="All company activity">-->
<!--            <i class="fas fa-stream"></i> &nbsp;View Activity-->
<!--          </button>-->

<!--          <div v-if="activity_loaded" class="row mt-1">-->
<!--            <div v-if="notEmptyObject(activity)" class="col-12">-->
<!--              <button v-for="log in activity" class="last_activity" :class="log_type(log.type)">-->
<!--                <span class="log_type">-->
<!--                  <span class="log_icon">{{ log.type | capitalLogType }}</span>-->
<!--                  <span class="log_type_info">-->
<!--                    <span v-if="'contact_id' in log && log.contact_id !== null">{{ log.contact.person.first_name }} {{ log.contact.person.surname }}</span>-->
<!--                    <span v-else-if="log.company_id !== null">{{ log.company.company_name }}</span>-->
<!--                    <br>-->
<!--                    <span v-if="'contact_info_model_type' in log">-->
<!--                      <span v-if="'contact_id' in log && log.contact_id !== null">Contact</span>-->
<!--                      <span v-else-if="log.company_id !== null">Company</span>-->
<!--                      {{ log.contact_info_model_type | modelLog }}-->
<!--                    </span>-->
<!--                    <span v-else>-->
<!--                      <span v-if="'contact_id' in log && log.contact_id !== null">Contact</span>-->
<!--                      <span v-else-if="log.company_id !== null">Company</span>-->
<!--                      Note-->
<!--                    </span>-->
<!--                    <span v-if="'company_model_type' in log">Company {{ log.company_model_type | modelLog }}</span>-->
<!--                    <span v-if="'contact_model_type' in log">Contact {{ log.contact_model_type | modelLog }}</span>-->
<!--                  </span>-->
<!--                  <span class="log_user_created_at">{{ log.log_by.first_name }} {{ log.log_by.surname }} - {{ log.updated_at | formatDateTime }}</span>-->
<!--                </span>-->
<!--              </button>-->
<!--            </div>-->
<!--            <div v-else class="col-12 ri_w_no_content">-->
<!--              <p class="ri_w_label">No Activity on Company.</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else class="row mt-2">-->
<!--            <div class="col-12">-->
<!--              <span class="ri_w_loading"><i class="fas fa-spinner fa-pulse"></i> &nbsp; loading Activity</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import loadingCube from "loaders/right_loader";

export default {
  name: "companies",
  components: {
    loadingCube
  },
  data() {
    return {
      company_loaded: false,
      company: {},

      contacts_loaded: false,
      contacts: {},

      notes_loaded: false,
      notes: {},

      files_loaded: false,
      files: {},
      files_uploaded: [],
      file_order: [],

      // activity_loaded: false,
      // activity: {}
    }
  },
  computed: {
    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    // activity_reload() {
    //   return this.$store.state.logs.reload_logs;
    // },
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'company/' + this.$store.state.right_info.data.id).then(company => {
      this.company = company.data;
      // Get company contacts
      this.get_company_contacts().then(() => {
        this.get_company_notes();
        // this.get_company_logs();
      });
      this.$nextTick(() => this.company_loaded = true);
    }).catch(error => console.log(error.response));
  },
  watch: {
    contact_reload(val) {
      if (val === true) {
        this.contacts_loaded = false;
        this.get_company_contacts()
      }
    },
    note_reload(val) {
      if (val === true) {
        this.notes_loaded = false;
        this.get_company_notes()
      }
    },
    // activity_reload(val) {
    //   if (val === true) {
    //     this.activity_loaded = false;
    //     this.get_company_logs()
    //   }
    // }
  },
  methods: {
    ...mapActions(['hideRightInfo']),

    /*
     * QUICK ACTIONS
     */
    close_right_info() {
      this.hideRightInfo();
      this.$store.commit('CLEAR_RIGHT_INFO_TABLE_ROW');
    },
    show_record_company() {
      this.$store.commit('CURRENT_RECORD_COMPANY_ID', this.company.id);
      this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/company/record');
        this.$tabs.refresh('/company/record', true)
      });
    },
    delete_company() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: 
          '<div class="snotifyToast__title">Confirm Delete Company</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to delete:<br>' +
          `<strong>${this.$store.state.right_info.data.company_name}</strong>` +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '<div style="margin-top:10px;">' +
          '<label for="deleteReason">Please provide a reason:</label><br>' +
          '<textarea id="deleteReason" style="width:100%; height:70px; margin-top:5px;" placeholder="Enter reason..."></textarea>' +
          '</div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              const reason = document.getElementById('deleteReason').value.trim();
              
              if (!reason) {
                alert('Please provide a reason before deleting.');
                return;
              }

              this.$store.commit('SET_DELETE_COMPANY_ID', this.company.id);
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'company/' + this.$store.state.right_info.data.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  deleted_reason: reason
                }
              }).then(() => {
                this.$bus.$emit('table::reload', {table: 'all_companies', type: 'delete'});
                this.$nextTick(() => this.close_right_info());
                this.$snotify.warning('Company "' + this.company.company_name + '" has been deleted.');
              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /*
     * Office 365
     */
    createEmail() {
      this.$router.push('/email/create');
    },
    createEvent() {
      this.$router.push('/calendar/event/create');
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    /*
     * GET RIGHT INFORMATION
     */
    get_company_contacts() {
      return axios.get(this.crmApiPath + 'contact/company/' + this.$store.state.right_info.data.id).then(contacts => {
        this.contacts = contacts.data;
        this.contacts_loaded = true;
      })
    },
    get_company_notes() {
      axios.get(this.crmApiPath + 'note/company/' + this.$store.state.right_info.data.id + '/last_5').then(company_notes => {
        this.notes = company_notes.data;
        this.notes_loaded = true;
      }).catch(error => console.log(error.response));
    },
    // get_company_files() {
    //
    // },

    /*
     * SECTION FUNCTIONS
     */
    add_contact_modal() {
      this.$store.commit('SHOW_ADD_CONTACT_MODAL', {
        company_id: this.company.id,
        company_name: this.company.company_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_contact_modal'));
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.company.id,
        name: this.company.company_name,
        type: 'company',
        contacts: this.contacts
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    view_note_modal(note_id, type, name) {
      this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
        id: note_id,
        name: name,
        type: type,
        contacts: this.contacts
      });
      this.$store.state.notes.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
    },
    // view_all_company_activity() {
    //   this.$store.commit('CURRENT_RECORD_COMPANY_ID', this.$store.state.right_info.data.id);
    //   this.$store.commit('SET_COMPANY_TAB_INDEX', 12);
    //   this.$nextTick(() => {
    //     this.$router.push('/company/record');
    //     this.$tabs.refresh('/company/record', true)
    //   });
    // },
    // log_type(type) {
    //   if (type === 'created') {
    //     return 'created';
    //   }
    //   else if (type === 'updated') {
    //     return 'updated';
    //   }
    //   else if (type === 'restored') {
    //     return 'restored';
    //   }
    //   else if (type === 'deleted') {
    //     return 'deleted';
    //   }
    // },
    // view_log_modal(log) {
    //   if ('contact_model_type' in log) {
    //     this.$store.commit('SHOW_VIEW_LOG_MODAL', {
    //       log_type: 'contact',
    //       id: log.id,
    //       log_by: log.user,
    //       log_by_id: log.log_by_id,
    //       new_values: log.new_values,
    //       old_note_by: log.old_note_by,
    //       old_values: log.old_values,
    //       type: log.type,
    //       updated_at: log.updated_at,
    //       contact_id: log.contact_id,
    //       contact_model_id: log.contact_model_id,
    //       contact_model_type: log.contact_model_type,
    //       company_id: log.company_id
    //     });
    //     this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
    //   }
    //   if ('company_model_type' in log) {
    //     this.$store.commit('SHOW_VIEW_LOG_MODAL', {
    //       log_type: 'company',
    //       id: log.id,
    //       log_by: log.user,
    //       log_by_id: log.log_by_id,
    //       new_values: log.new_values,
    //       old_note_by: log.old_note_by,
    //       old_values: log.old_values,
    //       type: log.type,
    //       updated_at: log.updated_at,
    //       contact_id: log.contact_id,
    //       company_id: log.company_id,
    //       company_model_id: log.company_model_id,
    //       company_model_type: log.company_model_type,
    //     });
    //     this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
    //   }
    // },
  },
  beforeDestroy() {
    this.company_loaded = false;
    this.company = {};
    this.contacts_loaded = false;
    this.contacts = {};
    this.notes_loaded = false;
    this.notes = {};
    this.files_loaded = false;
    this.files = {};
    this.files_uploaded = false;
    this.file_order = [];
    // this.activity_loaded = false;
    // this.activity = {};
  }
}
</script>

<style scoped lang="scss">
.r_h_100 {
  height: calc(100vh - 43px);
}

#company_right_info {
  width:       $right_info_width;
  padding-top: 0;

  .row {
    margin-right: 0;
    margin-left:  0;

    &.extra_neg_margin {
      margin-right: -10px;
      margin-left:  -10px;
    }
  }

  #ri_w_top {
    position:         fixed;
    height:           210px;
    background-color: $right_info_bg;
    right:            0;
    width:            400px;
    padding:          10px 20px 10px 10px;
    z-index:          9;
  }

  .ri_w_after_top {
    padding-top:    210px;
    width:          100%;
    padding-bottom: 20px;
    padding-right:  20px;
  }

  .quick_btns, .quick_action_btns {
    .orcaBtn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
    }
  }

  .ri_w_section {
    display:  block;
    position: relative;

    .sm-btn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
      float:       right;
    }

    .top_right_btn {
      position: absolute;
      right:    5px;
      top:      -5px;
    }

    .ri_w_label {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
    }

    .ri_w_no_content {
      background:     $red;
      padding-top:    5px;
      padding-bottom: 5px;

      .ri_w_label {
        color: $white;
      }
    }

    .ri_w_loading {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
      font-size:     1rem;
    }

    .latest_entity_test {
      margin-bottom: 0;

      &.Fail, &.Amber {
        color:          $white;
        padding-top:    5px;
        padding-bottom: 5px;
      }

      &.Fail {
        background: $red;
      }

      &.Amber {
        background: $orange;
      }

      &.Pass {
        .test_status {
          color: $green;
        }
      }

      button {
        float:          none;
        vertical-align: middle;
        margin-right:   10px;
      }

      .test_status {
        width:          70px;
        display:        inline-block;
        vertical-align: middle;
        line-height:    1.1;
        font-weight:    bold;
        font-size:      1rem;
        text-transform: uppercase;
      }

      .test_info {
        width:          calc(100% - 130px);
        display:        inline-block;
        vertical-align: middle;

        .test_date, .test_created_at {
          line-height: 1.1;
          display:     block;
          font-size:   0.625rem;
        }

        .test_date {
          font-weight: bold;
        }

        .test_created_at {
          margin-top: 3px;
        }
      }
    }

    #contacts_box {
      max-height: 200px;
      overflow-y: scroll;
    }

    .all_contacts {
      margin-top: 5px;
      background: lighten($bc_5, 12.5%);
      padding:    7.5px;

      .contact_details {
        width:          calc(100% - 56px);
        /*width:          100%;*/
        display:        inline-block;
        vertical-align: middle;

      }

      .contact_name, .contact_job_title {
        line-height: 1.1;
        display:     block;
      }

      .contact_name {
        font-weight: bold;
        font-size:   0.9rem;
      }

      .contact_job_title {
        margin-top:    3px;
        margin-bottom: 3px;
      }

      .contact_pm {
        display: inline-block;
        width:   47.5%;
      }

      .contact_e {
        display: block;
        width:   100%;
      }

      .contact_pm, .contact_e {
        i {
          color:        $bc_1;
          margin-right: 5px;
        }
      }
    }

    .last_notes {
      margin-bottom: 15px;

      button {
        float:          none;
        vertical-align: middle;
        margin-right:   10px;
      }

      .note_details {
        width:          calc(100% - 56px);
        display:        inline-block;
        vertical-align: middle
      }

      .note_on, .note_type, .note_title, .note_user_created_at {
        line-height: 1.1;
        display:     block;
      }

      .note_on {
        font-weight: bold;
        color:       $bc_1;
      }

      .note_type {
        font-weight: bold;
        font-size:   0.9rem;
      }

      .note_title {
        margin-top: 3px;
      }

      .note_user_created_at {
        font-size:  0.625rem;
        margin-top: 3px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .last_activity {
      margin-bottom: 3px;
      border:        none;
      background:    transparent;
      padding:       5px 5px 7px 5px;
      display:       block;
      width:         100%;
      text-align:    left;

      &:focus {
        outline: none;
      }

      .log_type {
        display:     block;
        font-weight: bold;

        .log_icon {
          font-size:      0.65rem;
          display:        inline-block;
          margin-right:   10px;
          border:         2px solid;
          border-radius:  50%;
          text-align:     center;
          height:         20px;
          width:          20px;
          line-height:    17px;
          vertical-align: top;
        }

        .log_type_info {
          display:     inline-block;
          width:       calc(100% - 35px);
          line-height: 1.2;
        }
      }

      .log_user_created_at {
        font-size:   0.65rem;
        line-height: 10px;
        height:      10px;
        display:     block;
        margin-left: 34px;
      }

      &.created, &.updated, &.restored, &.deleted {
        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          color:         $white;
          border-radius: $border-radius_2;
        }
      }

      &.created {
        color:        $green;
        border-color: $green;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $green;
        }
      }

      &.updated {
        color:        $blue;
        border-color: $blue;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $blue;
        }
      }

      &.restored {
        color:        $orange;
        border-color: $orange;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $orange;
        }
      }

      &.deleted {
        color:        $red;
        border-color: $red;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $red;
        }
      }
    }
  }

}
</style>
